/**
 * Built-in task-category presets. Studios extend via the
 * org-scoped `taskCategoryLibrary` collection but every studio
 * starts from these defaults.
 *
 * Mirrored across mobile + web — define once here.
 */

export type TaskCategoryOption = { key: string; label: string };

export const DEFAULT_TASK_CATEGORIES: TaskCategoryOption[] = [
  { key: 'electrical', label: 'Electrical' },
  { key: 'plumbing', label: 'Plumbing' },
  { key: 'woodwork', label: 'Woodwork' },
  { key: 'design', label: 'Design' },
  { key: 'cleaning', label: 'Cleaning' },
  { key: 'floor_cleaning', label: 'Floor Cleaning' },
  { key: 'floor_matting', label: 'Floor Matting' },
  { key: 'painting', label: 'Painting' },
  { key: 'false_ceiling', label: 'False Ceiling' },
  { key: 'tiling', label: 'Tiling' },
  { key: 'general', label: 'General' },
];

/** Slugify a free-text category label into a stable key. */
export function toCategoryKey(label: string): string {
  return (
    label
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '') || 'general'
  );
}
